import { Route, Routes } from "react-router-dom";
import LocalLawModule from ".";

const LocalLawRoute = () => {
  return (
    <Routes>
      <Route path="/:view" element={<LocalLawModule />} />
      <Route path="/*" element={<LocalLawModule />} />
    </Routes>
  );
};

export default LocalLawRoute;
